/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetUserDynamicPermissionsRequestPermissionsInner
 */
export interface SetUserDynamicPermissionsRequestPermissionsInner {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the SetUserDynamicPermissionsRequestPermissionsInner interface.
 */
export function instanceOfSetUserDynamicPermissionsRequestPermissionsInner(value: object): value is SetUserDynamicPermissionsRequestPermissionsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function SetUserDynamicPermissionsRequestPermissionsInnerFromJSON(json: any): SetUserDynamicPermissionsRequestPermissionsInner {
    return SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserDynamicPermissionsRequestPermissionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'enabled': json['enabled'],
    };
}

export function SetUserDynamicPermissionsRequestPermissionsInnerToJSON(json: any): SetUserDynamicPermissionsRequestPermissionsInner {
    return SetUserDynamicPermissionsRequestPermissionsInnerToJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestPermissionsInnerToJSONTyped(value?: SetUserDynamicPermissionsRequestPermissionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'enabled': value['enabled'],
    };
}

